import styles from './Answers.module.scss';

import { Button } from '@/components';
import { OpinionPollItem } from '@/modules/opinions';
import cn from 'classnames';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AnswerItem {
  itemId: string;
  title: string;
}

export const Answers = ({
  yes,
  no,
  onClick,
  multipleAnswers = false,
  answers = [],
  isDisabled = false,
  noClickable = false,
}: {
  yes: AnswerItem;
  no: AnswerItem;
  onClick?: (itemId: string) => void;
  isDisabled?: boolean;
  noClickable?: boolean;
  multipleAnswers?: boolean;
  answers?: OpinionPollItem[];
}) => {
  const [answerId, setAnswerId] = useState<string | null>(null);
  const { t } = useTranslation();

  const onNextClick = () => {
    if (onClick && answerId) onClick(answerId);
  };

  return (
    <div className={styles.answers}>
      {multipleAnswers && (
        <div className={styles.answersList}>
          {answers
            .filter((answer) => answer.title.length > 0)
            .map((answer) => (
              <div
                className={cn(
                  styles.answersListItem,
                  noClickable && styles.noClickable,
                  answerId === answer.itemId && styles.active,
                )}
                key={answer.itemId || answer.title}
                onClick={() => onClick && setAnswerId(answer.itemId)}
              >
                <div>
                  <span>{answer.title}</span>
                  {answerId === answer.itemId && onClick && (
                    <Button onClick={onNextClick} gradient>
                      {t('Next')}
                    </Button>
                  )}
                </div>
              </div>
            ))}
        </div>
      )}
      {!multipleAnswers && (
        <>
          {!!yes && (
            <div className={styles.answerWrapper}>
              <span
                className={cn(
                  styles.answerBlurWrapper,
                  styles.answerBlurWrapperPositive,
                )}
              />
              <button
                className={cn(
                  styles.positive,
                  noClickable && styles.noClickable,
                )}
                onClick={() => onClick && onClick(yes.itemId)}
                disabled={isDisabled}
              >
                {yes.title}
              </button>
            </div>
          )}
          {!!no && (
            <div className={styles.answerWrapper}>
              <span
                className={cn(
                  styles.answerBlurWrapper,
                  styles.answerBlurWrapperNegative,
                )}
              />
              <button
                className={cn(
                  styles.negative,
                  noClickable && styles.noClickable,
                )}
                onClick={() => onClick && onClick(no.itemId)}
                disabled={isDisabled}
              >
                {no.title}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
